export const TAB_BAR_FIELDS = [
    {
        key: 'tabBar.icon.size',
        label: '탭 아이콘 크기',
        help: '하단 탭(홈·마켓·커뮤니티·마이페이지) 아이콘의 크기입니다. 크게 하면 탭 바 높이도 그만큼 커집니다.',
        group: '아이콘',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 16,
        max: 36,
    },
    {
        key: 'tabBar.add.iconSize',
        label: '가운데 + 버튼 크기',
        help: '하단 탭 가운데 + 버튼(방송·상품 등록) 아이콘의 크기입니다.',
        group: '아이콘',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 16,
        max: 48,
    },
    {
        key: 'tabBar.label.fontSize',
        label: '탭 이름 글자 크기',
        help: '아이콘 아래 탭 이름의 글자 크기입니다. 화면 설정 공통의 하단 탭 「아이콘 아래 이름 표시」를 켠 경우에만 보입니다.',
        group: '탭 이름',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.2xs',
        min: 8,
        max: 16,
    },
    {
        key: 'tabBar.label.gap',
        label: '아이콘과 탭 이름 사이',
        help: '탭 아이콘과 그 아래 탭 이름 사이의 간격입니다.',
        group: '탭 이름',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.xxs',
        min: 0,
        max: 12,
    },
    {
        key: 'tabBar.withLabel.paddingTop',
        label: '위 여백 (탭 이름 보일 때)',
        help: '탭 이름을 보이게 했을 때 탭 아이콘 위의 여백입니다. 탭 바 높이가 함께 바뀝니다.',
        group: '높이(위아래 여백)',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s',
        min: 0,
        max: 32,
    },
    {
        key: 'tabBar.withLabel.paddingBottom',
        label: '아래 여백 (탭 이름 보일 때)',
        help: '탭 이름을 보이게 했을 때 탭 이름 아래의 여백입니다(기기 아래쪽 안전 영역은 따로 더해집니다).',
        group: '높이(위아래 여백)',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.xs',
        min: 0,
        max: 32,
    },
    {
        key: 'tabBar.noLabel.paddingTop',
        label: '위 여백 (탭 이름 숨길 때)',
        help: '탭 이름을 숨겼을 때 탭 아이콘 위의 여백입니다. 탭 바 높이가 함께 바뀝니다.',
        group: '높이(위아래 여백)',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.m-plus',
        min: 0,
        max: 32,
    },
    {
        key: 'tabBar.noLabel.paddingBottom',
        label: '아래 여백 (탭 이름 숨길 때)',
        help: '탭 이름을 숨겼을 때 탭 아이콘 아래의 여백입니다(기기 아래쪽 안전 영역은 따로 더해집니다).',
        group: '높이(위아래 여백)',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s',
        min: 0,
        max: 32,
    },
    {
        key: 'tabBar.border.visible',
        label: '위 테두리 보이기',
        help: '하단 탭 바 맨 위의 얇은 구분선입니다. 끄면 화면 내용과 탭 바 사이에 선이 없습니다.',
        group: '테두리',
        type: 'boolean',
        defaultValue: true,
    },
];
//# sourceMappingURL=tabBar.js.map